import { render } from "./Authenticated.vue?vue&type=template&id=7412da4a"
import script from "./Authenticated.vue?vue&type=script&setup=true&lang=js"
export * from "./Authenticated.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Layouts/Authenticated.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7412da4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7412da4a', __exports__)) {
    api.reload('7412da4a', __exports__)
  }
  
  module.hot.accept("./Authenticated.vue?vue&type=template&id=7412da4a", () => {
    api.rerender('7412da4a', render)
  })

}


export default __exports__